import React from 'react'
import {Box} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'

interface SurveyDialogNewProps {
  open: boolean
  onClose: () => void
  survey?: Record<string, any>
}

export default function SurveyDialogNew({open, onClose, survey}: SurveyDialogNewProps): JSX.Element {
  const title = survey?.name || 'Questionario'

  return (
    <AppDialog open={open} onClose={onClose} title={title} maxWidth="lg">
      {survey?.formDataId && (
        <Box
          component="iframe"
          src={`/form-service/#/visualizer/${survey.formDataId}`}
          title={title}
          sx={{width: '100%', height: '70vh', border: 'none'}}
        />
      )}
    </AppDialog>
  )
}
